// this is temporary
export default function (entry) {
	return `
		${this.render('form/field/label', entry)}
		${this.render('form/field/inputWrapper', this.render('form/field/sumTable', entry))}
	`;
}
